import React, { MouseEventHandler } from 'react';
import PreventClickOnDrag from '../interaction/PreventClickOnDrag';

export interface GroupRowProps<T> {
  onClick: MouseEventHandler<HTMLDivElement>;
  onDoubleClick?: MouseEventHandler<HTMLDivElement>;
  onContextMenu?: MouseEventHandler<HTMLDivElement>;
  isEvenRow?: boolean;
  style?: React.CSSProperties;
  clickTolerance?: number;
  group: T;
  horizontalLineClassNamesForGroup?: (group: T) => string[];
}

function GroupRow<T>({
  onContextMenu,
  onDoubleClick,
  isEvenRow,
  style,
  onClick,
  clickTolerance,
  horizontalLineClassNamesForGroup,
  group,
}: GroupRowProps<T>) {
  let classNamesForGroup: string[] = [];
  if (horizontalLineClassNamesForGroup) {
    classNamesForGroup = horizontalLineClassNamesForGroup(group);
  }

  return (
    <PreventClickOnDrag clickTolerance={clickTolerance} onClick={onClick}>
      <div
        onContextMenu={onContextMenu}
        onDoubleClick={onDoubleClick}
        className={
          (isEvenRow ? 'rct-hl-even ' : 'rct-hl-odd ') +
          (classNamesForGroup ? classNamesForGroup.join(' ') : '')
        }
        style={style}
      />
    </PreventClickOnDrag>
  );
}

GroupRow.displayName = 'GroupRow';

export default GroupRow;
